import {
  baseScreen,
} from 'hoc';
import React,
{
  useRef,
} from 'react';
import GeneralTableView from 'src/components/GeneralTableView';
import i18n from 'i18n-js';
import {
  useStores,
} from 'hooks';
import {
  toJS,
} from 'mobx';
import {
  FilterTypes,
  TableColumnTypes,
} from 'src/components/GeneralTableView/types';
import {
  Assets,
} from 'assets';
import AddIcon from '@material-ui/icons/Add';
import {
  useHistory,
} from 'react-router';
import {
  InsuranceCompany,
} from './types';

const insuranceCompanies: React.FC = () => {
  const {
    backend: {
      insuranceCompaniesStore,
    },
  } = useStores();
  const history = useHistory();
  const ref = useRef<any|null>(null);
  return (
    <div>
      <GeneralTableView<InsuranceCompany>
        tableProps={{
          tableRef: ref,
          options: {
            actionsColumnIndex: 10,
            search: false,
            paging: false,
          },
          title: i18n.t('INSURANCE_COMPANIES'),
          actions: [
            // {
            //   icon: () => (
            //     <img
            //       src={Assets.images.common.trash}
            //       alt={i18n.t('DELETE')}
            //     />
            //   ),
            //   onClick: async (event, data) => {
            //     if (!Array.isArray(data)) {
            //       const response = window.confirm(i18n.t('DELETE_INSURANCE_COMPANY_CONFIRMATION'));
            //       if (response) {
            //         await insuranceCompaniesStore.delete(data.id as number);
            //         if (ref && ref.current) {
            //           ref.current.onQueryChange();
            //         }
            //       }
            //     }
            //   },
            // },
            {
              icon: () => (
                <img
                  src={Assets.images.common.edit}
                  alt={i18n.t('EDIT')}
                />
              ),
              onClick: async (event, data) => {
                const type: any = data;
                history.push(`/insurance-companies-form/${type.id}`);
              },
            },
            {
              isFreeAction: true,
              icon: AddIcon,
              onClick: () => {
                history.push('/insurance-companies-form/:id');
              },
              tooltip: i18n.t('ADD_NEW_INSURANCE_COMPANY'),
            },
          ],
        }}
        options={{
          search: false,
          pageSize: 10,
          filtering: false,
        }}
        get={async (query) => {
          const res = await insuranceCompaniesStore.getAll(query);
          return {
            data: toJS(res).map((item) => new InsuranceCompany(item)),
            totalCount: 10,
            page: 1,
          };
        }}
        tableColumns={[
          {
            field: 'id',
            title: i18n.t('ID'),
            type: TableColumnTypes.NUMERIC,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'englishName',
            title: i18n.t('ENGLISH_TITLE'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'arabicName',
            title: i18n.t('ARABIC_TITLE'),
            type: TableColumnTypes.STRING,
            filterType: FilterTypes.VALUE,
          },
          {
            field: 'logo',
            title: i18n.t('LOGO'),
            type: TableColumnTypes.STRING,
            columnProps: {
              render: (data) => (
                <img
                  src={data.logo}
                  style={{
                    width: 40,
                  }}
                  alt={data.englishName}
                />
              ),
            },
          },
        ]}
      />
    </div>
  );
};

export const InsuranceCompanies = baseScreen(insuranceCompanies, {
  allowedRoles: ['ADMIN', 'NONE'],
});
